import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_Slider_1.jpg';
import projectImage2 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_Slider_5.jpg';

import Data_AgnicoEagleExperience from './Data_AgnicoEagleExperience';

function Work_AgnicoEagleExperience() {
    return (
        <>
            <DetailedHeader
                heading="Explore the Mining Lifecycle from Every Angle"
                client="Agnico Eagle"
                service="Virtual 360 Experience"
                date="2026"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=RJ91jHcOdt8"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Agnico Eagle mining lifecycle 360 experience',
                    },
                    {
                        image: projectImage2,
                        alt: 'Agnico Eagle mining lifecycle 360 experience',
                    },
                    {
                        image: projectImage3,
                        alt: 'Agnico Eagle mining lifecycle 360 experience',
                    },
                    {
                        image: projectImage4,
                        alt: 'Agnico Eagle mining lifecycle 360 experience',
                    },
                    {
                        image: projectImage5,
                        alt: 'Agnico Eagle mining lifecycle 360 experience',
                    },
                ]}
            />

            {Data_AgnicoEagleExperience.content}
        </>
    );
}

export default Work_AgnicoEagleExperience;
